import React, { Component } from "react";

class Filter extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }
  handleClick(e) {
    e.preventDefault();

    this.props.onFilterChange(this.props.id);
  }
  render() {
    var classes = ["filter-toggle"];

    if (this.props.stepChosenId == this.props.id) {
      classes.push("filter-toggle--active");
    }

    return (
      <a href="#" className={classes.join(" ")} onClick={this.handleClick}>
        {this.props.name}
      </a>
    );
  }
}

export default Filter;
